import { Link, useLocation } from "react-router-dom";
import { FishingDiscipline, useFishingDiscipline } from "../types/fishingDiscipline";
import "./publicSite/PublicPages.css";

export default function DisciplineNavigation({ admin = false }: { admin?: boolean }) {
  const discipline = useFishingDiscipline();
  const location = useLocation();
  const page = location.pathname.replace(/^\/carpe/, "");
  const target = admin ? (["/dashboard", "/leagues", "/classifiche"].includes(page) ? page : "/dashboard")
    : (["/gare", "/campionati", "/statistiche"].includes(page) ? page : "/gare");
  return (
    <nav aria-label="Discipline di pesca" className="discipline-navigation">
      {[
        { value: FishingDiscipline.TroutArea, label: "Trout Area", path: target },
        { value: FishingDiscipline.CarpAndCrucian, label: "Carpe e Carassi", path: `/carpe${target}` },
      ].map(item => (
        <Link key={item.value} to={item.path} aria-current={discipline === item.value ? "page" : undefined}
          className="discipline-navigation__link">
          {item.label}
        </Link>
      ))}
    </nav>
  );
}
